
import { Title } from 'lib-core'


export default Title
